// extracted by mini-css-extract-plugin
module.exports = {"alcohol-restriction-warning":"AlcoholRestrictionWarning_alcohol-restriction-warning__3KbEh","icon":"AlcoholRestrictionWarning_icon__3epu-"};